import { dataShareAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShareAltSolid = /*#__PURE__*/createIcon(dataShareAltSolid)
export default IconShareAltSolid
